import { useContentTracking } from "../../screens/Detail/use-content-tracking"
import { playerStore } from "../../store/PlayerStore"

export const usePlayerTracking = (eventName?: string) => {
  const content = playerStore((state) => state.content)
  const isPreview = playerStore((state) => state.isPreview)
  return useContentTracking({
    eventName: eventName ?? "content_interaction",
    content,
    overrideType: isPreview ? "Trailer" : undefined,
    isPageTracking: false,
    pageType: "Player",
  })
}
